import { useRef } from 'react';
import { useDebounce, useIntersection } from 'react-use';

import Loader from '~components/generic/loader/Loader';

export function LoadMoreTrigger({ onLoadMore }: { onLoadMore: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  const intersection = useIntersection(ref, {
    root: null,
    rootMargin: '50px',
    threshold: 0,
  });

  useDebounce(
    () => {
      if (!intersection) return;
      if (!intersection.isIntersecting) return;
      onLoadMore?.();
    },
    200,
    [intersection],
  );

  return (
    <div ref={ref} className="relative flex items-center justify-center">
      <div className="relative w-16 h-8">
        <Loader absoluteCenter={true} />
      </div>
    </div>
  );
}
